import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6 lg:p-8 bg-white rounded-lg mb-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold text-primary-500 mb-2.5" }, "V. Medication History 服用中のお薬", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "If you are taking any medication, please fill out the table below", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-darkgray-800 mb-5" }, "薬を服用している場合は、以下の表に記入してください。", -1)
const _hoisted_5 = {
  key: 0,
  class: "col-span-full text-right"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "col-span-full lg:col-span-4" }
const _hoisted_8 = { class: "col-span-full lg:col-span-4" }
const _hoisted_9 = { class: "col-span-full lg:col-span-4" }

import TextInput from '@/components/inputs/TextInput.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MedicationHistory',
  props: {
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: false
    },
},
  setup(__props) {

const props = __props

const item = ref(props.form)

const addRow = () => {
    item.value.push({
        medication_name: null,
        illness_symptom_name: null,
        intake_schedule: null,
    })
}

const remove = (index : string) => {
    item.value.splice(index, 1);
}

const schedules = (['1', '2', '3', '4', '5'])



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (history, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-4 bg-primary-50 rounded-2xl p-5 lg:p-7 mb-2",
        key: index
      }, [
        (index >= '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (!__props.disableInputs)
                ? (_openBlock(), _createElementBlock("small", {
                    key: 0,
                    onClick: ($event: any) => (remove(index)),
                    class: "text-red-500 cursor-pointer text-sm"
                  }, "Remove", 8, _hoisted_6))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            modelValue: history.medication_name,
            "onUpdate:modelValue": ($event: any) => ((history.medication_name) = $event),
            id: "name-of-medication",
            type: "text",
            placeholder: "Name of Medication / 薬の名前",
            disabled: __props.disableInputs
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(TextInput, {
            modelValue: history.illness_symptom_name,
            "onUpdate:modelValue": ($event: any) => ((history.illness_symptom_name) = $event),
            id: "name-of-illness",
            type: "text",
            placeholder: "Name of illness/symptom / 病名・症状",
            disabled: __props.disableInputs
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(MultiselectInput, {
            disabled: __props.disableInputs,
            id: "schedule-of-intake",
            modelValue: history.intake_schedule,
            "onUpdate:modelValue": ($event: any) => ((history.intake_schedule) = $event),
            placeholder: "Schedule of intake / 服薬の頻度・スケジュール",
            options: schedules
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
        ])
      ]))
    }), 128)),
    (!__props.disableInputs)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          onClick: addRow,
          class: "font-bold text-primary-500 hover:text-primary-700 transition cursor-pointer text-sm w-fit"
        }, " Add another + "))
      : _createCommentVNode("", true)
  ]))
}
}

})